import { useState } from "react";

export default function StatusDropdown() {
  const [status, setStatus] = useState("Active");
  const [open, setOpen] = useState(false);

  const isActive = status === "Active";

  const handleSelect = (value) => {
    setStatus(value);
    setOpen(false); // close after selection
  };

  return (
    <div className="relative inline-block text-left">
      {/* Button */}
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 border rounded-lg px-3 py-3 w-[140px] h-[44px] text-sm w-32 justify-between"
      >
        <div className="flex items-center gap-2">
          <span
            className={`w-2 h-2 rounded-full ${
              isActive ? "bg-green-500" : "bg-orange-500"
            }`}
          ></span>
          {status}
        </div>
        <svg
          className={`w-4 h-4 text-gray-600 transform transition-transform ${
            open ? "rotate-180" : "rotate-0"
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {/* Dropdown */}
      {open && (
        <div className="absolute mt-1 w-32 bg-white border rounded-lg shadow-lg z-10">
          <div
            onClick={() => handleSelect("Active")}
            className="flex items-center gap-2 px-3 py-2 text-sm cursor-pointer hover:bg-gray-100"
          >
            <span className="w-2 h-2 rounded-full bg-green-500"></span>
            Active
          </div>
          <div
            onClick={() => handleSelect("Inactive")}
            className="flex items-center gap-2 px-3 py-2 text-sm cursor-pointer hover:bg-gray-100"
          >
            <span className="w-2 h-2 rounded-full bg-orange-500"></span>
            Inactive
          </div>
        </div>
      )}
    </div>
  );
}
